import useKlydoQuery from './useKlydoQuery';
import labelsApiClient from '../api/labels';

export const useLabelsQuery = (query: string) => {
  return useKlydoQuery({
    queryKey: ['labels-search', query],
    queryFn: () => labelsApiClient.searchCollectionLabels(query),
    staleTime: 5 * 60 * 1000,
  });
};
